import React from 'react';
import { Button } from 'antd';
import { DownloadOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';

interface SuccessStepProps {
  userEmail?: string;
  userFirstName?: string;
  userLastName?: string;
}

const SuccessStep: React.FC<SuccessStepProps> = ({
  userEmail,
  userFirstName,
  userLastName
}) => {
  const navigate = useNavigate();

  return (
    <div className="activation-step">
      <div className="activation-step__content">
        <div className="activation-success activation-success--compact">
        <p className="activation-step__subtitle">
            Thank you {userFirstName} {userLastName}
          </p>
          <p className="activation-step__subtitle" style={{ textAlign: 'left' }}>
          You have activated your one year subscription to <br/> TruHu with the email: {userEmail}
          </p>


          <Button
            type="primary"
            size="large"
            icon={<DownloadOutlined />}
            onClick={() => navigate('/download')}
            className="activation-download-btn"
          >
            Download TruHu
          </Button>
        </div>
      </div>
    </div>
  );
};

export default SuccessStep;
